import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Clock, Lock } from 'lucide-react';
import { useAuth } from '../AuthContext';

function fmt(iso) {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' }); }
  catch { return '—'; }
}

export function SubscriptionBanner() {
  const { subscription } = useAuth();
  if (!subscription) return null;

  if (subscription.status === 'trial') {
    return (
      <div className="mb-6 flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-amber-200 bg-amber-50 p-5" data-testid="trial-banner">
        <div className="flex items-start gap-3">
          <Sparkles size={22} className="mt-0.5 shrink-0 text-amber-600" />
          <div>
            <p className="font-display text-lg text-paelbi-ink">Prova gratuita PLUS attiva</p>
            <p className="text-sm text-paelbi-ink/70">
              <span data-testid="trial-days" className="font-semibold text-amber-700">{subscription.days_remaining} giorni</span> rimanenti · scade il {fmt(subscription.trial_end)}
            </p>
          </div>
        </div>
        <Link to="/admin/subscription" data-testid="banner-choose-plan"
          className="inline-flex items-center gap-2 rounded-btn bg-paelbi-brown px-5 py-2.5 text-sm font-semibold text-white hover:bg-paelbi-brown-dark">
          Scegli il tuo piano
        </Link>
      </div>
    );
  }

  if (subscription.status === 'expired' || subscription.status === 'suspended') {
    return (
      <div className="mb-6 overflow-hidden rounded-2xl border border-paelbi-line bg-white shadow-card" data-testid="expired-paywall">
        <div className="flex flex-col items-center gap-3 bg-paelbi-ink px-6 py-10 text-center text-white">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-white/10"><Lock size={26} /></div>
          <h2 className="font-display text-2xl">Il tuo periodo di prova è terminato</h2>
          <p className="max-w-lg text-sm text-white/75">
            Continua ad offrire un&apos;esperienza digitale ai tuoi ospiti scegliendo uno dei piani Domira.
          </p>
          <Link to="/admin/subscription" data-testid="paywall-choose-plan"
            className="mt-2 inline-flex items-center gap-2 rounded-btn bg-white px-6 py-2.5 text-sm font-semibold text-paelbi-ink hover:bg-white/90">
            Scegli il tuo piano
          </Link>
        </div>
      </div>
    );
  }

  // active
  return (
    <div className="mb-6 flex items-center gap-3 rounded-2xl border border-green-200 bg-green-50 p-4 text-sm" data-testid="active-banner">
      <Clock size={18} className="text-green-600" />
      <span className="text-paelbi-ink/80">Piano <span className="font-semibold capitalize">{subscription.plan}</span> attivo · rinnovo il {fmt(subscription.subscription_end)}</span>
      <Link to="/admin/subscription" className="ml-auto text-paelbi-brown hover:underline">Gestisci</Link>
    </div>
  );
}

export default SubscriptionBanner;
